module.exports = __webpack_public_path__ + "img/764739_D0917B_2A1611_B37C68-256px.513cca4e.png";